export default {
      id: "caret-down-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-46b249.svg#caret-down-usage",
      toString: function () {
        return this.url;
      }
    }